import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "logMealsBeforeEating",
  "accountabilityPartner",
  "mealPrepAndRecipes",
  "trackingStreak",
  "watchCalorieIntake",
  "notSureYet",
] as const

export default function StayOnTrack() {
  return <MultiSelectPage translationKey="stayOnTrack" options={OPTIONS} />
}
